<template>
  <div class="app-container">
    <el-card class="main-card">
      <div slot="header" class="clearfix">
        <span class="page-title">vivo账户批量操作</span>
      </div>

      <div class="operation-section">
        <el-row :gutter="15" class="button-row">
          <el-col :span="4">
            <el-button type="primary" size="small" @click="batchUpdateDeliveryDate" class="operation-btn">投放日期
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="small" @click="batchUpdateDeliveryTime" class="operation-btn">投放时段
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="small" @click="batchUpdateOcpxPrice" class="operation-btn">修改出价
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="small" @click="batchUpdateDailyBudget" class="operation-btn">广告组日限额
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="danger" size="small" @click="batchPauseGroups" class="operation-btn">关闭广告组</el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="success" size="small" @click="batchStartGroups" class="operation-btn">开启广告组
            </el-button>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="button-row">
          <el-col :span="4">
            <el-button type="danger" size="small" @click="batchPausePlans" class="operation-btn">关闭计划</el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="success" size="small" @click="batchStartPlans" class="operation-btn">开启计划</el-button>
          </el-col>

          <el-col :span="4">
            <el-button type="danger" size="small" @click="batchDeletePlans" class="operation-btn">删除计划</el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="small" @click="batchUpdatePlanDailyBudget" class="operation-btn">
              计划日限额
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="small" @click="batchOrientation" class="operation-btn">定向年龄/性别
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="small" @click="showRegionSelector" class="operation-btn">定向区域
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="small" @click="batchUpdateTogether" class="operation-btn">一键起量
            </el-button>
          </el-col>
          <!--          <el-col :span="4">-->
          <!--            <el-button type="primary" size="small" @click="batchReserveFastFlowInsert" class="operation-btn">预约一键起量</el-button>-->
          <!--          </el-col>-->
          <!--          <el-col :span="4">-->
          <!--            <el-button type="primary" size="small" @click="openReservationView" class="operation-btn">查看预约</el-button>-->
          <!--          </el-col>-->
          <el-col :span="4">
            <el-button type="danger" size="small" @click="batchCloseFastFlow" class="operation-btn">关闭一键起量
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="small" @click="showTargetPackageDialog" class="operation-btn">定向包</el-button>
          </el-col>
        </el-row>
      </div>

      <div class="input-section">
        <el-form :model="form" label-width="100px" size="small">
          <el-form-item label="地区" style="margin-left: 0;">
            <el-select v-model="form.area" placeholder="请选择地区" class="custom-select" style="width: 250px;">
              <el-option label="浙江" value="1"></el-option>
              <el-option label="福建" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="账户名" style="margin-left: 0;">
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入内容，每行一个"
              v-model="form.textListRaw"
              style="width: 100%;"
              spellcheck="false"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>

    </el-card>

    <!-- 定向包选择弹窗 -->
    <el-dialog
      title="定向包设置"
      :visible.sync="targetPackageDialogVisible"
      width="40%">
      <el-form :model="targetPackageForm" label-width="100px" size="small">
        <el-form-item label="推广目标">
          <el-select v-model="targetPackageForm.adType" placeholder="请选择推广目标" style="width: 100%;">
            <el-option label="普通网址" value="1"></el-option>
            <el-option label="应用推广" value="2"></el-option>
            <el-option label="快应用/游戏" value="8"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="计划类型">
          <el-select v-model="targetPackageForm.mediaType" placeholder="请选择计划类型" style="width: 100%;">
            <el-option label="非商店" value="1"></el-option>
            <el-option label="联盟" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="queryTargetPackages" :loading="packageQueryLoading">查询</el-button>
        </el-form-item>

        <el-form-item label="定向包" v-if="targetPackages.length > 0">
          <el-select v-model="selectedTargetPackage" placeholder="请选择定向包" style="width: 100%;">
            <el-option
              v-for="item in targetPackages"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
    <el-button @click="targetPackageDialogVisible = false" size="small">取 消</el-button>
    <el-button
      type="primary"
      @click="confirmTargetPackage"
      size="small"
      :disabled="!selectedTargetPackage">
      调整定向
    </el-button>
  </span>
    </el-dialog>

    <!-- 参数设置弹窗 -->
    <el-dialog
      :title="'设置参数 - ' + currentApiTitle"
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      v-if="shouldShowDialog">

      <el-form :model="form" label-width="130px" size="small">

        <!-- 根据不同接口显示特定参数 -->
        <div v-if="currentApi === '/batchUpdateDeliveryDate'">
          <el-form-item label="开始日期">
            <el-date-picker
              v-model="extraParams.startDate"
              type="date"
              placeholder="选择开始日期"
              value-format="yyyy-MM-dd"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker
              v-model="extraParams.endDate"
              type="date"
              placeholder="选择结束日期"
              value-format="yyyy-MM-dd"
              style="width: 100%;">
            </el-date-picker>
            <div class="el-form-item__tip">如设置长期有效，则不需要选择结束日期</div>
          </el-form-item>
        </div>

        <div v-if="currentApi === '/batchUpdateDeliveryTime'">
          <el-form-item label="时段设置">
            <div v-for="(timeRange, index) in timeRanges" :key="index" class="time-range-item">
              <el-time-select
                placeholder="起始时间"
                v-model="timeRange.startTime"
                :picker-options="timePickerOptions">
              </el-time-select>
              <span class="time-range-separator">-</span>
              <el-time-select
                placeholder="结束时间"
                v-model="timeRange.endTime"
                :picker-options="Object.assign({}, timePickerOptions, {minTime: timeRange.startTime})">
              </el-time-select>
              <el-button
                v-if="timeRanges.length > 1"
                icon="el-icon-delete"
                circle
                size="mini"
                @click="removeTimeRange(index)"
                class="delete-time-range-btn">
              </el-button>
            </div>
            <el-button
              type="primary"
              plain
              size="mini"
              @click="addTimeRange"
              class="add-time-range-btn">
              + 添加时段
            </el-button>
          </el-form-item>
        </div>

        <div v-if="currentApi === '/batchUpdateOcpxPrice'">
          <el-form-item label="调整方式">
            <el-select v-model="extraParams.priceAdjustType" placeholder="请选择调整方式" style="width: 100%;">
              <el-option label="直接设置" value="set"></el-option>
              <el-option label="提高" value="increase"></el-option>
              <el-option label="降低" value="decrease"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="出价" v-if="extraParams.priceAdjustType === 'set'">
            <el-input v-model="extraParams.ocpxPrice" placeholder="请输入出价"></el-input>
            <div class="el-form-item__tip">单位：元</div>
          </el-form-item>

          <div v-if="extraParams.priceAdjustType === 'increase'">
            <el-form-item label="提高方式">
              <el-select v-model="extraParams.increaseType" placeholder="请选择提高方式" style="width: 100%;">
                <el-option label="按百分比" value="multiplier"></el-option>
                <el-option label="按金额" value="amount"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              :label="extraParams.increaseType === 'multiplier' ? '百分比' : '金额'">
              <el-input
                v-model="extraParams.increaseValue"
                :placeholder="extraParams.increaseType === 'multiplier' ? '例如：20 表示提高20%' : '请输入金额'">
              </el-input>
              <div class="el-form-item__tip">
                {{ extraParams.increaseType === 'multiplier' ? '例如：20 表示提高20%' : '单位：元' }}
              </div>
            </el-form-item>
          </div>

          <div v-if="extraParams.priceAdjustType === 'decrease'">
            <el-form-item label="降低方式">
              <el-select v-model="extraParams.decreaseType" placeholder="请选择降低方式" style="width: 100%;">
                <el-option label="按百分比" value="multiplier"></el-option>
                <el-option label="按金额" value="amount"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              :label="extraParams.decreaseType === 'multiplier' ? '百分比' : '金额'">
              <el-input
                v-model="extraParams.decreaseValue"
                :placeholder="extraParams.decreaseType === 'multiplier' ? '例如：20 表示降低20%' : '请输入金额'">
              </el-input>
              <div class="el-form-item__tip">
                {{ extraParams.decreaseType === 'multiplier' ? '例如：20 表示降低20%' : '单位：元' }}
              </div>
            </el-form-item>
          </div>
        </div>

        <div v-if="currentApi === '/batchUpdateDailyBudget' || currentApi === '/batchUpdatePlanDailyBudget'">
          <el-form-item
            label="日限额"
            prop="dailyBudget"
            :rules="[
              { validator: validateDailyBudget, trigger: 'blur' },
              { validator: validateDailyBudget, trigger: 'change' }
            ]"
          >
            <el-input
              v-model="extraParams.dailyBudget"
              placeholder="请输入日限额"
              oninput="value = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')"
            ></el-input>
            <div class="el-form-item__tip">单位：元，不填写则设为无限</div>
          </el-form-item>
        </div>

        <div v-if="currentApi === '/batchOrientation'">
          <el-form-item label="年龄段">
            <el-checkbox v-model="ageUnlimited" @change="toggleAgeUnlimited">不限</el-checkbox>
            <el-checkbox-group v-model="extraParams.ageList" @change="handleAgeListChange">
              <el-checkbox label="25">0-17岁</el-checkbox>
              <el-checkbox label="26">18-24岁</el-checkbox>
              <el-checkbox label="27">25-29岁</el-checkbox>
              <el-checkbox label="28">30-39岁</el-checkbox>
              <el-checkbox label="29">40-49岁</el-checkbox>
              <el-checkbox label="30">50岁及以上</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="性别">
            <el-checkbox v-model="sexUnlimited" @change="toggleSexUnlimited">不限</el-checkbox>
            <el-checkbox-group v-model="extraParams.sexList" @change="handleSexListChange">
              <el-checkbox label="19">男</el-checkbox>
              <el-checkbox label="20">女</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>

        <div v-if="currentApi === '/batchUpdateTogether'">
          <el-form-item label="起量预算" prop="fastFlowBudget">
            <el-input
              v-model="extraParams.fastFlowBudget"
              placeholder="请输入起量预算">
            </el-input>
            <div class="el-form-item__tip">
              请输入不低于200的数值，单位为元。输入后请检查确认一键起量预算设置，提交后当日内不支持修改起量预算。
            </div>
          </el-form-item>
        </div>

        <div v-if="currentApi === '/batchReserveFastFlowInsert'">
          <el-form-item label="任务名称">
            <el-input
              v-model="extraParams.taskName"
              placeholder="请输入任务名称">
            </el-input>
          </el-form-item>
          <el-form-item label="预约时间">
            <el-date-picker
              v-model="extraParams.executeTime"
              type="datetime"
              placeholder="请选择预约时间"
              value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="起量预算" prop="fastFlowBudget">
            <el-input
              v-model="extraParams.fastFlowBudget"
              placeholder="请输入起量预算">
            </el-input>
            <div class="el-form-item__tip">
              请输入不低于200的数值，单位为元。输入后请检查确认一键起量预算设置，提交后当日内不支持修改起量预算。
            </div>
          </el-form-item>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <div class="button-group" v-if="currentApi === '/batchUpdateTogether'">
          <el-button type="primary" size="small" @click="batchReserveFastFlowInsert">预约一键起量</el-button>
          <el-button type="primary" size="small" @click="openReservationView">查看预约</el-button>
          <el-button @click="dialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="confirmCall" size="small">确 定</el-button>
        </div>
        <div class="button-group" v-else>
          <el-button @click="dialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="confirmCall" size="small">确 定</el-button>
        </div>
      </span>
    </el-dialog>
    <Region ref="Region" @confirm="handleRegionConfirm"></Region>

    <!-- 添加加载提示框 -->
    <el-dialog
      :visible.sync="loadingDialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%">
      <div style="text-align: center; padding: 20px;">
        <i class="el-icon-loading" style="font-size: 30px; color: #409EFF;"></i>
        <p style="margin-top: 10px;">正在处理中，请稍候...</p>
      </div>
    </el-dialog>
    <ReservationView ref="reservationView"></ReservationView>
  </div>
</template>

<script>
import Region from './Region.vue';
import ReservationView from './ReservationView.vue'

export default {
  name: 'BatchEdit',
  components: {
    Region,
    ReservationView
  },
  data() {
    return {
      reservationViewVisible: false,
      dialogVisible: false,
      currentApi: '',
      currentApiTitle: '',
      form: {
        area: '1', // 默认选择浙江
        textListRaw: '',
        textList: []
      },
      extraParams: {
        startDate: '',
        endDate: '',
        scheduleTime: Array(336).fill(true),
        price: '0',
        ocpxPrice: '',
        dailyBudget: '',
        ageList: [],
        sexList: [],
        regionCodeList: '',
        // 新增出价调整相关参数
        priceAdjustType: 'set', // set: 直接设置, increase: 提高, decrease: 降低
        increaseType: 'multiplier', // multiplier: 按倍数, amount: 按金额
        increaseValue: '',
        decreaseType: 'multiplier', // multiplier: 按倍数, amount: 按金额
        decreaseValue: '',
        fastFlowBudget: '',
        fastFlowState: '1',
        executeTime: '',
        taskName: '',
      },
      timeRanges: [
        {startTime: '00:00', endTime: '24:00'}
      ],
      timePickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '24:00'
      },
      // 添加加载提示相关数据
      loadingDialogVisible: false,
      // 添加不限选项相关变量
      ageUnlimited: true,
      sexUnlimited: true,
      // 添加标志防止循环更新
      updatingAgeList: false,
      updatingSexList: false,
      // 定向包相关数据
      targetPackageDialogVisible: false,
      targetPackageForm: {
        adType: '',
        campaignType: 0,
        mediaType: '',
        pushForm: null,
        pushType: null,
      },
      targetPackages: [],
      selectedTargetPackage: '',
      packageQueryLoading: false
    }
  },
  computed: {
    shouldShowDialog() {
      const showableApis = [
        '/batchUpdateDeliveryDate',
        '/batchUpdateDeliveryTime',
        '/batchOrientation',
        '/batchEditAge',
        '/batchUpdateOcpxPrice',
        '/batchUpdateDailyBudget',
        '/batchUpdatePlanDailyBudget',
        '/batchEditSex',
        '/batchEditRegion',
        '/batchUpdateTogether',
        '/batchReserveFastFlowInsert'
      ];
      return showableApis.includes(this.currentApi);
    },
    dialogWidth() {
      if (this.currentApi === '/batchUpdateDeliveryTime') {
        return '40%';
      }
      return '25%';
    }
  },
  watch: {
    'form.textListRaw': function (newVal) {
      this.form.textList = newVal.split('\n').filter(item => item.trim() !== '');
    }
  },
  methods: {
    openReservationView() {
      this.$refs.reservationView.open()
    },
    // 显示定向包弹窗
    showTargetPackageDialog() {
      this.targetPackageDialogVisible = true;
      this.targetPackageForm = {
        adType: '',
        mediaType: ''
      };
      this.targetPackages = [];
      this.selectedTargetPackage = '';
    },

    // 查询定向包
    queryTargetPackages() {
      // 验证必填字段
      if (!this.targetPackageForm.adType) {
        this.$message.warning('请选择推广目标');
        return;
      }

      if (!this.targetPackageForm.mediaType) {
        this.$message.warning('请选择计划类型');
        return;
      }

      // 添加textList校验
      if (!this.form.textList || this.form.textList.length === 0) {
        this.$message.warning('请至少输入一个账户名');
        return;
      }

      // 显示加载状态
      this.packageQueryLoading = true;

      import('@/api/modules/vivoBatchEditApi.js').then(module => {
        const apiModule = module.default;
        const requestData = {
          area: this.form.area,
          textList: [this.form.textList[0]],
          adType: this.targetPackageForm.adType,
          mediaType: this.targetPackageForm.mediaType,
          pushType: this.targetPackageForm.pushType,
          pushForm: this.targetPackageForm.pushForm,
          campaignType: this.targetPackageForm.campaignType
        };

        apiModule.getAllRegionPackages(requestData).then(response => {
          this.packageQueryLoading = false;
          if (response.data && response.data.code === "0") {
            this.targetPackages = response.data.data || [];
            this.$message.success('查询成功');
          } else {
            const message = response.data && response.data.message ? response.data.message : '查询失败';
            this.$message.error('查询失败: ' + message);
          }
        }).catch(error => {
          this.packageQueryLoading = false;
          this.$message.error('查询失败: ' + (error.response && error.response.data && error.response.data.message ? error.response.data.message : '未知错误'));
        });
      }).catch(error => {
        this.packageQueryLoading = false;
        this.$message.error('API模块加载失败: ' + error.message);
      });
    },

    // 确认定向包设置
    confirmTargetPackage() {
      if (!this.selectedTargetPackage) {
        this.$message.warning('请选择定向包');
        return;
      }

      // 显示加载提示框
      this.loadingDialogVisible = true;

      import('@/api/modules/vivoBatchEditApi.js').then(module => {
        const apiModule = module.default;
        const requestData = {
          area: this.form.area,
          textList: this.form.textList,
          audiencePkgName: this.selectedTargetPackage,
          adType: this.targetPackageForm.adType,
          mediaType: this.targetPackageForm.mediaType
        };

        // 调用正确的API方法 batchBindPkg
        apiModule.batchBindPkg(requestData).then(response => {
          // 隐藏加载提示框
          this.loadingDialogVisible = false;

          if (response.data && response.data.code === "0") {
            // 准备表格数据
            const tableData = [];
            let successCount = 0;
            let failCount = 0;

            // 按照输入顺序处理结果
            this.form.textList.forEach((text, index) => {
              let result = '设置成功';
              if (response.data.data && response.data.data.hasOwnProperty(text)) {
                result = response.data.data[text];
              }

              // 判断成功或失败
              if (result.includes('绑定失败') || result.includes('无有效广告组ID')) {
                failCount++;
              } else {
                successCount++;
              }

              tableData.push({
                account: text,
                result: result
              });
            });

            // 创建表格HTML
            let tableHtml = `
          <div style="max-height: 400px; overflow-y: auto;">
            <table class="result-table" style="width: 100%; border-collapse: collapse; text-align: left;">
              <thead>
                <tr style="background-color: #f5f7fa;">
                  <th style="border: 1px solid #ebeef5; padding: 8px;">账户名</th>
                  <th style="border: 1px solid #ebeef5; padding: 8px;">执行结果</th>
                </tr>
              </thead>
              <tbody>
        `;

            tableData.forEach((item, index) => {
              const isFail = item.result.includes('绑定失败') || item.result.includes('无有效广告组ID');
              const rowStyle = isFail ? 'color: #f56c6c; background-color: #fef0f0;' : 'color: #67c23a; background-color: #f0f9ff;';

              tableHtml += `
            <tr style="${rowStyle}">
              <td style="border: 1px solid #ebeef5; padding: 8px;">${item.account}</td>
              <td style="border: 1px solid #ebeef5; padding: 8px;">${item.result}</td>
            </tr>
          `;
            });

            tableHtml += `
              </tbody>
            </table>
          </div>
        `;

            // 显示结果信息
            this.$alert(tableHtml, '设置结果', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定'
            });

            if (failCount === 0) {
              this.$message.success('定向包设置完成');
            } else if (successCount > 0) {
              this.$message.warning(`部分设置成功，成功${successCount}个，失败${failCount}个`);
            } else {
              this.$message.error('定向包设置全部失败');
            }

            this.targetPackageDialogVisible = false;
          } else {
            const message = response.data && response.data.message ? response.data.message : '设置失败';
            this.$message.error('设置失败: ' + message);
          }
        }).catch(error => {
          // 隐藏加载提示框
          this.loadingDialogVisible = false;
          this.$message.error('设置失败: ' + (error.response && error.response.data && error.response.data.message ? error.response.data.message : '未知错误'));
        });
      }).catch(error => {
        // 隐藏加载提示框
        this.loadingDialogVisible = false;
        this.$message.error('API模块加载失败: ' + error.message);
      });
    },


    // 年龄不限切换方法
    toggleAgeUnlimited(checked) {
      if (checked) {
        // 如果选中不限，则清空具体选项
        this.extraParams.ageList = [];
      }
      // 如果取消不限，保持当前选择状态不变
    },

    // 性别不限切换方法
    toggleSexUnlimited(checked) {
      if (checked) {
        // 如果选中不限，则清空具体选项
        this.extraParams.sexList = [];
      }
      // 如果取消不限，保持当前选择状态不变
    },

    // 年龄选项变化处理
    handleAgeListChange(value) {
      this.updatingAgeList = true;
      // 如果选择了具体选项，则取消不限的选择
      if (value.length > 0) {
        this.ageUnlimited = false;
      }
      // 如果取消所有选项，则自动选择不限
      else {
        this.ageUnlimited = true;
      }
      this.$nextTick(() => {
        this.updatingAgeList = false;
      });
    },

    // 性别选项变化处理
    handleSexListChange(value) {
      this.updatingSexList = true;
      // 如果选择了具体选项，则取消不限的选择
      if (value.length > 0) {
        this.sexUnlimited = false;
      }
      // 如果取消所有选项，则自动选择不限
      else {
        this.sexUnlimited = true;
      }
      this.$nextTick(() => {
        this.updatingSexList = false;
      });
    },

    validateDailyBudget(rule, value, callback) {
      // 空值不校验（允许设为无限）
      if (!value) {
        return callback();
      }

      // 金额校验正则：正数，最多两位小数
      const reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;

      if (!reg.test(value)) {
        return callback(new Error('请输入有效的金额（最多两位小数）'));
      }

      callback();
    },
    timeToIndex(timeString) {
      if (!timeString) return 0;
      const [hours, minutes] = timeString.split(':').map(Number);
      // 关键修改：移除 Math.min(47, ...)，允许 24:00 计算为 48
      const halfHourPeriods = Math.floor(hours * 2 + minutes / 30);
      // 仅限制最小值为0，不限制最大值（24:00会得到48）
      return Math.max(0, halfHourPeriods);
    },
    addTimeRange() {
      this.timeRanges.push({
        startTime: '00:00',
        endTime: '24:00'
      });
    },
    removeTimeRange(index) {
      this.timeRanges.splice(index, 1);
    },

    // 显示区域选择器
    showRegionSelector() {
      this.$refs.Region.dialogVisible = true;
    },
    // 处理区域选择确认事件
    handleRegionConfirm(provinceIds, cityIds, stayType) {
      // 构建请求数据
      const requestData = {
        area: this.form.area,
        textList: this.form.textList,
        // 如果选择了不限，则regionCodeList为null
        regionCodeList: provinceIds === null && cityIds === null ? null :
          [...(provinceIds || []), ...(cityIds || [])], // 安全地合并数组
        stayType: stayType
      };
      // 直接调用API
      this.callApi('/batchEditRegion', requestData);
    },
    // 设置当前操作和标题
    setCurrentOperation(api, title) {
      this.currentApi = api;
      this.currentApiTitle = title;
      this.dialogVisible = true;

      // 初始化投放时段数据
      if (api === '/batchUpdateDeliveryTime') {
        this.timeRanges = [
          {startTime: '00:00', endTime: '24:00'}
        ];
      }
    },

    // 批量修改投放日期
    batchUpdateDeliveryDate() {
      this.setCurrentOperation('/batchUpdateDeliveryDate', '批量修改投放日期');
    },

    // 批量修改投放时段
    batchUpdateDeliveryTime() {
      this.setCurrentOperation('/batchUpdateDeliveryTime', '批量修改投放时段');
    },

    // 批量修改出价
    batchUpdateOcpxPrice() {
      this.setCurrentOperation('/batchUpdateOcpxPrice', '批量修改出价');
    },

    // 批量修改日限额
    batchUpdateDailyBudget() {
      this.setCurrentOperation('/batchUpdateDailyBudget', '批量修改日限额');
    },

    // 批量关闭广告组
    batchPauseGroups() {
      this.$confirm('请确认是否关闭广告组?', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const requestData = {
          area: this.form.area,
          textList: this.form.textList
        };
        this.callApi('/batchPauseGroups', requestData);
      }).catch(() => {
        // 用户点击取消
      });
    },

    // 批量开启广告组
    batchStartGroups() {
      this.$confirm('请确认是否开启广告组?', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const requestData = {
          area: this.form.area,
          textList: this.form.textList
        };
        this.callApi('/batchStartGroups', requestData);
      }).catch(() => {
        // 用户点击取消
      });
    },

    // 批量关闭广告计划
    batchPausePlans() {
      this.$confirm('请确认是否关闭广告计划?', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const requestData = {
          area: this.form.area,
          textList: this.form.textList
        };
        this.callApi('/batchPausePlans', requestData);
      }).catch(() => {
        // 用户点击取消
      });
    },

    // 批量开启广告计划
    batchStartPlans() {
      this.$confirm('请确认是否开启广告计划?', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const requestData = {
          area: this.form.area,
          textList: this.form.textList
        };
        this.callApi('/batchStartPlans', requestData);
      }).catch(() => {
        // 用户点击取消
      });
    },

    // 批量删除广告计划
    batchDeletePlans() {
      this.$confirm('此操作将永久删除广告计划, 是否继续?', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const requestData = {
          area: this.form.area,
          textList: this.form.textList
        };
        this.callApi('/batchDeletePlans', requestData);
      }).catch(() => {
        // 用户点击取消
        this.$message.info('已取消删除操作');
      });
    },

    // 批量修改计划日限额
    batchUpdatePlanDailyBudget() {
      this.setCurrentOperation('/batchUpdatePlanDailyBudget', '批量修改计划日限额');
    },

    // 批量修改定向年龄
    batchEditAge() {
      this.setCurrentOperation('/batchEditAge', '批量修改定向年龄');
    },

    // 批量修改定向性别
    batchEditSex() {
      this.setCurrentOperation('/batchEditSex', '批量修改定向性别');
    },

    // 批量修改定向区域
    batchEditRegion() {
      this.setCurrentOperation('/batchEditRegion', '批量修改定向区域');
    },

    batchOrientation() {
      this.setCurrentOperation('/batchOrientation', '定向设置');
    },

    // 新增一键起量方法
    batchUpdateTogether() {
      this.setCurrentOperation('/batchUpdateTogether', '一键起量');
    },

    // 添加预约一键起量方法
    batchReserveFastFlowInsert() {
      this.setCurrentOperation('/batchReserveFastFlowInsert', '预约一键起量');
    },

    // 新增关闭一键起量方法
    batchCloseFastFlow() {
      this.$confirm('确定要关闭一键起量功能吗?', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const requestData = {
          area: this.form.area,
          textList: this.form.textList,
          fastFlowState: '3' // 关闭一键起量
        };
        this.callApi('/batchCloseUpdateTogether', requestData);
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },

    // 确认调用接口
    confirmCall() {
      // 构建基础请求参数
      const requestData = {
        area: this.form.area,
        textList: this.form.textList
      };
      // 根据不同接口添加特定参数
      switch (this.currentApi) {
        case '/batchUpdateDeliveryDate':
          requestData.startDate = this.extraParams.startDate;
          requestData.endDate = this.extraParams.endDate;
          break;
        case '/batchUpdateDeliveryTime':
          // 校验时段设置：下一个时段的起始时间不能在上一个时段结束之前
          const sortedTimeRanges = [...this.timeRanges].sort((a, b) => {
            return a.startTime.localeCompare(b.startTime);
          });
          for (let i = 0; i < sortedTimeRanges.length - 1; i++) {
            const currentRange = sortedTimeRanges[i];
            const nextRange = sortedTimeRanges[i + 1];

            // 如果当前时段的结束时间晚于下一时段的开始时间，则报错
            if (currentRange.endTime && nextRange.startTime &&
              currentRange.endTime > nextRange.startTime) {
              this.$message.error('时段设置有冲突：下一个时段的起始时间不能在上一个时段结束之前');
              return;
            }
          }
          // 生成336位的字符串，表示一周内每半小时的时间段选择情况
          // 每天48个时间段，一周7天，共336个时间段
          let dailySchedule = new Array(48).fill('0');
          // 根据timeRanges设置选中的时间段（一天的模板）
          this.timeRanges.forEach(range => {
            if (range.startTime && range.endTime) {
              const startIndex = this.timeToIndex(range.startTime);
              const endIndex = this.timeToIndex(range.endTime);

              // 关键修改：将上限从47改为48，允许endIndex=48时覆盖到索引47
              const maxIndex = Math.min(endIndex, 48);
              // 循环条件改为 i < maxIndex，当maxIndex=48时，i会从startIndex到47（共48个时间段）
              for (let i = startIndex; i < maxIndex; i++) {
                // 确保不越界（仅处理0-47的索引）
                if (i >= 0 && i < 48) {
                  dailySchedule[i] = '1';
                }
              }
            }
          });
          // 将一天的模板复制7天形成完整的336位字符串
          requestData.scheduleTime = Array(7).fill(dailySchedule.join('')).join('');
          break;
        case '/batchUpdateOcpxPrice':
          // 根据不同调整方式设置参数
          if (this.extraParams.priceAdjustType === 'set') {
            // 直接设置模式
            const price = parseFloat(this.extraParams.ocpxPrice);
            // 写一个更严格的判断：
            // 1.不能为空或空字符串
            // 2.只能为数字
            // 3.最多两位小数
            if (!this.extraParams.ocpxPrice || !/^\d+(\.\d{1,2})?$/.test(this.extraParams.ocpxPrice)) {
              this.$message.error('价格必须是有效数字');
              return;
            }
            requestData.ocpxPrice = price.toFixed(2);
          } else if (this.extraParams.priceAdjustType === 'increase') {
            // 提高模式
            if (!this.extraParams.increaseValue) {
              this.$message.error('请输入提高值');
              return;
            }
            requestData.type = '0'; // 0表示提高
            if (this.extraParams.increaseType === 'multiplier') {
              // 按百分比提高
              const percentage = parseFloat(this.extraParams.increaseValue);
              // 写一个更严格的判断：
              // 1.不能为空或空字符串
              // 2.只能为数字且只能为整数
              // 3.只能输入1-100
              if (!this.extraParams.increaseValue || !/^\d+$/.test(this.extraParams.increaseValue) || percentage < 1 || percentage > 100) {
                this.$message.error('百分比必须在1-100之间');
                return;
              }
              // 转换为小数形式，例如输入20，转换为0.2
              requestData.multiple = (percentage / 100).toFixed(4);
            } else {
              // 按金额提高
              const amount = parseFloat(this.extraParams.increaseValue);
              // 写一个更严格的判断：
              // 1.不能为空或空字符串
              // 2.只能为数字
              // 3.最多两位小数
              if (!this.extraParams.increaseValue || !/^\d+(\.\d{1,2})?$/.test(this.extraParams.increaseValue)) {
                this.$message.error('金额必须是有效数字');
                return;
              }
              requestData.limit = amount.toFixed(2);
            }
          } else if (this.extraParams.priceAdjustType === 'decrease') {
            // 降低模式
            if (!this.extraParams.decreaseValue) {
              this.$message.error('请输入降低值');
              return;
            }
            requestData.type = '1'; // 1表示降低
            if (this.extraParams.decreaseType === 'multiplier') {
              // 按百分比降低
              const percentage = parseFloat(this.extraParams.decreaseValue);
              // 写一个更严格的判断：
              // 1.不能为空或空字符串
              // 2.只能为数字且只能为整数
              // 3.只能输入1-100
              if (!this.extraParams.decreaseValue || !/^\d+$/.test(this.extraParams.decreaseValue) || percentage < 1 || percentage > 100) {
                this.$message.error('百分比必须在1-100之间');
                return;
              }
              // 转换为小数形式，例如输入20，转换为0.2
              requestData.multiple = (percentage / 100).toFixed(4);
            } else {
              // 按金额降低
              const amount = parseFloat(this.extraParams.decreaseValue);
              // 写一个更严格的判断：
              // 1.不能为空或空字符串
              // 2.只能为数字
              // 3.最多两位小数
              if (!this.extraParams.decreaseValue || !/^\d+(\.\d{1,2})?$/.test(this.extraParams.decreaseValue)) {
                this.$message.error('金额必须是有效数字');
                return;
              }
              requestData.limit = amount.toFixed(2);
            }
          }
          requestData.price = this.extraParams.price;
          break;
        case '/batchUpdateDailyBudget':
        case '/batchUpdatePlanDailyBudget':
          // 处理日限额参数
          requestData.dailyBudget = this.extraParams.dailyBudget;
          break;
        case '/batchEditAge':
          requestData.ageList = this.extraParams.ageList;
          break;
        case '/batchEditSex':
          requestData.sexList = this.extraParams.sexList;
          break;
        case '/batchUpdateTogether':
          requestData.fastFlowState = this.extraParams.fastFlowState;
          requestData.fastFlowBudget = this.extraParams.fastFlowBudget;
          break;
        case '/batchReserveFastFlowInsert':
          if (!this.extraParams.taskName) {
            this.$message.error('请输入任务名称');
            return;
          }
          if (!this.extraParams.executeTime) {
            this.$message.error('请选择预约时间');
            return;
          }
          // 验证预约时间是否在未来
          const now = new Date();
          const executeTime = new Date(this.extraParams.executeTime);
          if (executeTime <= now) {
            this.$message.error('预约时间必须在未来');
            return;
          }
          requestData.taskName = this.extraParams.taskName;
          requestData.executeTime = this.extraParams.executeTime;
          requestData.fastFlowState = this.extraParams.fastFlowState;
          requestData.fastFlowBudget = this.extraParams.fastFlowBudget;
          break;
        case '/batchOrientation':
          // 处理年龄定向
          // 只有明确选择"不限"时才传null，全选时传所有选项值
          requestData.ageList = this.ageUnlimited ? null : this.extraParams.ageList;

          // 处理性别定向
          // 只有明确选择"不限"时才传null，全选时传所有选项值
          requestData.sexList = this.sexUnlimited ? null : this.extraParams.sexList;

          this.callOrientationApis(requestData);
          return;
      }
      // 调用接口
      this.callApi(this.currentApi, requestData);
    },

    // 实际调用接口的方法
    callApi(api, data) {
      // 根据接口路径映射到具体的API方法
      const apiMap = {
        '/batchUpdateDeliveryDate': 'batchUpdateDeliveryDate',
        '/batchUpdateDeliveryTime': 'batchUpdateDeliveryTime',
        '/batchUpdateOcpxPrice': 'batchUpdateOcpxPrice',
        '/batchUpdateDailyBudget': 'batchUpdateDailyBudget',
        '/batchPauseGroups': 'batchPauseGroups',
        '/batchStartGroups': 'batchStartGroups',
        '/batchPausePlans': 'batchPausePlans',
        '/batchStartPlans': 'batchStartPlans',
        '/batchUpdatePlanDailyBudget': 'batchUpdatePlanDailyBudget',
        '/batchEditAge': 'batchEditAge',
        '/batchEditSex': 'batchEditSex',
        '/batchEditRegion': 'batchEditRegion',
        '/batchDeletePlans': 'batchDeletePlans',
        '/batchOrientation': 'batchOrientation',
        '/batchUpdateTogether': 'batchUpdateTogether',
        '/batchReserveFastFlowInsert': 'batchReserveFastFlowInsert',
        '/batchCloseUpdateTogether': 'batchCloseUpdateTogether'
      };
      // 获取对应的方法名
      const methodName = apiMap[api];
      if (!methodName) {
        this.$message.error('未找到对应的API方法');
        return;
      }

      // 显示加载提示框
      this.loadingDialogVisible = true;

      // 导入API模块
      import('@/api/modules/vivoBatchEditApi.js').then(module => {
        const apiModule = module.default;
        // 调用对应的方法
        apiModule[methodName](data).then(response => {
          // 隐藏加载提示框
          this.loadingDialogVisible = false;

          // 检查code字段是否为0表示成功
          if (response.data && response.data.code === "0") {
            this.$message.success('修改成功');
            this.dialogVisible = false;
          } else {
            // code不为0表示失败，显示错误信息
            const message = response.data && response.data.message ? response.data.message : '操作失败';
            this.$message.error('调用失败: ' + message);
            this.dialogVisible = false;
          }
        }).catch(error => {
          // 隐藏加载提示框
          this.loadingDialogVisible = false;

          // 处理网络错误或其他异常
          this.$message.error('调用失败: ' + (error.response && error.response.data && error.response.data.message ? error.response.data.message : '未知错误'));
          this.dialogVisible = false;
        });
      }).catch(error => {
        // 隐藏加载提示框
        this.loadingDialogVisible = false;

        this.$message.error('API模块加载失败: ' + error.message);
      });
    },
    // 专门用于处理定向设置的接口调用方法
    callOrientationApis(data) {
      // 显示加载提示框
      this.loadingDialogVisible = true;

      // 导入API模块
      import('@/api/modules/vivoBatchEditApi.js').then(module => {
        const apiModule = module.default;

        // 构建年龄设置的请求数据
        const ageData = {
          area: data.area,
          textList: data.textList,
          ageList: data.ageList
        };

        // 构建性别设置的请求数据
        const sexData = {
          area: data.area,
          textList: data.textList,
          sexList: data.sexList
        };

        // 并行调用两个接口
        Promise.all([
          apiModule.batchEditAge(ageData),
          apiModule.batchEditSex(sexData)
        ]).then(responses => {
          // 隐藏加载提示框
          this.loadingDialogVisible = false;

          // 检查两个接口的返回结果
          const [ageResponse, sexResponse] = responses;

          const ageSuccess = ageResponse.data && ageResponse.data.code === "0";
          const sexSuccess = sexResponse.data && sexResponse.data.code === "0";

          if (ageSuccess && sexSuccess) {
            this.$message.success('定向设置成功');
            this.dialogVisible = false;
          } else {
            let message = '';
            if (!ageSuccess && !sexSuccess) {
              // 两个接口都失败，显示各自的错误信息
              const ageMessage = ageResponse.data && ageResponse.data.message ? ageResponse.data.message : '年龄设置失败';
              const sexMessage = sexResponse.data && sexResponse.data.message ? sexResponse.data.message : '性别设置失败';
              message = `年龄设置失败: ${ageMessage}; 性别设置失败: ${sexMessage}`;
            } else if (!ageSuccess) {
              // 仅年龄设置失败
              const ageMessage = ageResponse.data && ageResponse.data.message ? ageResponse.data.message : '年龄设置失败';
              message = `年龄设置失败: ${ageMessage}`;
            } else {
              // 仅性别设置失败
              const sexMessage = sexResponse.data && sexResponse.data.message ? sexResponse.data.message : '性别设置失败';
              message = `性别设置失败: ${sexMessage}`;
            }
            this.$message.error(message);
            this.dialogVisible = false;
          }
        }).catch(error => {
          // 隐藏加载提示框
          this.loadingDialogVisible = false;

          // 处理网络错误或其他异常
          this.$message.error('调用失败: ' + (error.response && error.response.data && error.response.data.message ? error.response.data.message : '未知错误'));
          this.dialogVisible = false;
        });
      }).catch(error => {
        // 隐藏加载提示框
        this.loadingDialogVisible = false;

        this.$message.error('API模块加载失败: ' + error.message);
      });
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 84px);
  font-size: 16px;
}

.main-card {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  font-size: 16px;
}

.page-title {
  font-size: 20px;
  font-weight: bold;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.operation-section {
  margin-bottom: 25px;
  padding: 20px;
  background-color: #f0f2f5;
  border-radius: 6px;
}

.button-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.operation-btn {
  margin-bottom: 15px;
  width: 90%;
  font-size: 14px;
  height: 36px;
}

.input-section {
  padding: 20px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 16px;
}

.dialog-footer {
  text-align: right;
}

.schedule-table {
  width: 100%;
  border-collapse: collapse;
}

.schedule-table th,
.schedule-table td {
  border: 1px solid #ebeef5;
  padding: 5px; /* 减小内边距 */
  text-align: center;
}

.schedule-table th:first-child,
.schedule-table td:first-child {
  width: 50px; /* 调整首列宽度 */
}

.time-range-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.time-range-separator {
  margin: 0 10px;
}

.delete-time-range-btn {
  margin-left: 10px;
}

.add-time-range-btn {
  margin-top: 10px;
}

/* 新增样式 */
.time-range-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.time-range-separator {
  margin: 0 10px;
}

.delete-time-range-btn {
  margin-left: 10px;
}

.add-time-range-btn {
  margin-top: 10px;
}

.progress-log {
  margin-top: 20px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 6px;
  font-size: 14px;
  max-height: 200px;
  overflow-y: auto;
}

.log-item {
  margin: 5px 0;
  color: #666;
}

</style>

<style scoped>.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/vivo/BatchEdit.vue